import { createContext, useEffect, useState } from 'react';
import { CustomOfferGroup } from '../offerGroup/types';
import useCustomOffer from '../offerGroup/useCustomOffers';

export const CampaignContext = createContext<ICampaignContext>({} as any);

export type ICampaignContext = {
  offerGroups: CustomOfferGroup[];
};


const CampaignProvider: React.FC<any> = ({ children }) => {
  const [offerGroups, setOfferGroups] = useState<CustomOfferGroup[]>([]);

  const offerGroupApi = useCustomOffer();

  const initOfferGroups = () => {
    const apiCall = offerGroupApi.getOfferGroups();

    apiCall
      .call()
      .then((groups) => {
        setOfferGroups(groups);
      })
      .catch();

    return apiCall.abort;
  };

  useEffect(() => {
    return initOfferGroups();
  }, []);

  const values = {
    offerGroups,
  };
  return (
    <CampaignContext.Provider value={values}>
      {children}
    </CampaignContext.Provider>
  );
};

export default CampaignProvider;
